import { render, staticRenderFns } from "./FindUser.vue?vue&type=template&id=87bd5b12"
import script from "./FindUser.vue?vue&type=script&lang=js"
export * from "./FindUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports